import type { Metadata } from '../logger.types'

export function prepareMetadata(metadata: Metadata): Metadata {
	return Object.keys(metadata).reduce((acc, key) => {
		let value = metadata[key]
		if (value instanceof Error) {
			value = value.toString()
		}
		return { ...acc, [key]: value }
	}, {})
}
